module.exports = __webpack_public_path__ + "img/dashboard.2d860432.svg";